module.exports = __webpack_public_path__ + "temperature.png";